// employees/EmployeeContext.js
import React, { createContext, useContext, useState, useMemo, useEffect, useCallback } from 'react';
import {itemRender, handlePageChange, defaultPagination, pageSizeOptions} from "utils/table";
import {getAllResumeApi} from "api/services/resume"
import { useSearchParams } from 'react-router-dom';
import useResumeFilter from "../hooks/filterHook"
import {  useNavigate, useLocation } from "react-router-dom";
import {format} from "date-fns"
import { filterHandler } from 'utils/common';
import { useMediaQuery } from "react-responsive";

						

									  

// Create the Resume context
const resumeContext = createContext();

// Custom hook for accessing Resume context easily
export const useResume = () => {
  return useContext(resumeContext); 
};

// ResumeProvider component to wrap around components needing access to Resume data
export const ResumeProvider = ({ children }) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

    const navigate = useNavigate()

    const location = useLocation()

  const [loading, setLoading] = useState(false);
  const [selectedPage, setSelectedPage] = useState(0);
												   

  
  const [resumeData, setResumeData] = useState([]);
  const [view, setView] = useState(isMobile ? "grid" : "list");
  const [showFilterDrawer, setShowFilterDrawer] = useState(false)
  const [pageSettings , setPageSettings] = useState({
    ...defaultPagination,
    page: searchParams.get("page") || 1,
    pageSize: searchParams.get("size") || 50,
    sortType: searchParams.get("sort_type") || "",
    sortBy: searchParams.get("sort_by") || "",
    job: searchParams.get("job") || "",

})
const { handleFilterChange,
    filters,
    handleInputChange, filterLoading, setFilterLoading, handleDateChange, handleClearAll,
    isFilterDirty, setIsFilterDirty} = useResumeFilter(pageSettings , setPageSettings);

const getFilterParams = useCallback(()=>{
  let filter_params = filterHandler(filters)
    return filter_params
        
})

const setResumeParams = (pageData) => {
    let filter_params = getFilterParams()
    let params = {
        size: pageData?.pageSize,
        page: pageData?.page,
        sort_by: pageData?.sortBy || "",
        sort_type: pageData?.sortType || "",
        job: pageData?.job || "",
        is_internal_referral: pageData?.is_internal_referral || "",
        ...filter_params
    }
    setSearchParams(params)
}



    const getResumeList = () => {

        setLoading(true)
        setFilterLoading(true)      
        let filter_params = getFilterParams()

        if(filter_params?.applied_at_after){
            filter_params.applied_at_after = format(new Date(filter_params.applied_at_after), "yyyy-MM-dd")
        }
        if(filter_params?.applied_at_before){
            filter_params.applied_at_before = format(new Date(filter_params.applied_at_before), "yyyy-MM-dd")
        }


          
        getAllResumeApi({
          sort_by:pageSettings?.sortBy,
          sort_type: pageSettings?.sortType,
          page_size: pageSettings?.pageSize,
          page: pageSettings?.page,
          job: pageSettings?.job,
          ...filter_params
    
        }).then(response=>{
          console.log(response.data.results, "resultsss---->>>")
          setResumeData(response.data.results);
          setPageSettings((prev) => ({
            ...prev,
            total: response.data.count
          }))
    
          setLoading(false)
          setFilterLoading(false)
        }).catch(e=>{
          setLoading(false)
        })
    }
  useEffect(()=>{

    getResumeList()

  },[pageSettings?.page, pageSettings?.pageSize, pageSettings?.sortBy, pageSettings?.sortType, pageSettings?.filters])

  useEffect(()=>{
    setResumeParams(pageSettings)
  },[pageSettings])

  const handleApplyFilter = () => {
    setShowFilterDrawer(false)
    setIsFilterDirty(false)
    setPageSettings({
        ...pageSettings,
        page: 1,
        filters
      })

  }


  const handleGridChange = (page, size) =>{
    setPageSettings({
      ...pageSettings,
      pageSize: size,
      page,
    })				 
			 
	
  }


  const handleChange = (pagination, filters, sorter) => {
    let pageData = handlePageChange(pagination, filters, sorter, pageSettings)
    console.log(pageData)
    setPageSettings(pageData)
  }; 
							
		
  

  const handleFilterDrawer = () => {
    console.log("JJJJJJJ")
    setShowFilterDrawer(!showFilterDrawer)
    setFilterLoading(false)
  }


  const handleEmployeeDetailPage = (id, index) => {
								  
    navigate(`/resume/${id}`)
    setSelectedPage(index)
  }



  // Value to be provided to context consumers
  // Memoize the context value to avoid unnecessary re-renders
  const value = useMemo(() => ({
    resumeData, setResumeData,
    loading, setLoading,
   
    view, setView,
    pageSettings , setPageSettings,
    showFilterDrawer, setShowFilterDrawer,

    filterLoading, setFilterLoading,
    selectedPage, setSelectedPage,

    handleGridChange,
    handleChange,

    handleFilterDrawer,

    handleFilterChange,
    filters,
    handleInputChange,
    handleApplyFilter,
    handleEmployeeDetailPage,
    handleDateChange,
    handleClearAll,
    getResumeList,
    isFilterDirty

  }), [resumeData , view, loading, pageSettings, showFilterDrawer, filters, filterLoading, selectedPage, isFilterDirty]);

  return (
    <resumeContext.Provider value={value}>
      {children}
    </resumeContext.Provider>
  );
};